export default __webpack_public_path__ + "static/default_thumb-6bc8cabac87942f1167d2a5f1ffc3cfd.jpg";